import { HelpPage } from "./help-model";

const text = 
`**Siglas**
- **CPL:** Custo por lead
- **CPM:** Custo por mil impressões
- **CPI:** Custo por impressão

**Investimento e Orçamento**
- **Orçamento:** Valor alvo para o investimento durante o mês.
- **Orçamento Diário:** Valor do orçamento dividido pelo número de dias no mês.

**Números relacionados aos leads**
- **Meta:** Número de leads almejados pelo mês
- **Meta Proporcional:** Número de leads que deveria ter no momento multiplicando a meta diaria pelo número de dias passados até agora.
- **Meta diária:** Número de leads almejados pelo mês dividido pelo número de dias no mês.
- **Média diária:** Número de leads até o momento divido pelo número de dias até agora.



`

export const summaryHelp = {
    title: "Sumário",
    body: text
} as HelpPage
